import { describeError } from "../lib/api";
import { Button } from "./Button";

/**
 * A failed screen load: what went wrong, a "Try again" button and, for our own faults, a reference
 * the office can look up. Never a blank screen.
 */
export function ErrorState({ error, onRetry, retrying }: { error: unknown; onRetry?: () => void; retrying?: boolean }) {
  const v = describeError(error);
  return (
    <div className={`error-state error-state--${v.kind}`} role="alert">
      <p className="error-state__msg">{v.message}</p>
      {v.reference && <p className="error-state__ref">Reference: <span className="mono">{v.reference}</span></p>}
      {onRetry && <Button variant="secondary" small busy={retrying} onClick={onRetry}>Try again</Button>}
    </div>
  );
}
